import React from 'react';

import Loading from '../../../Common/Loading';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';
import './styles/Charts.css';
import { CallsTimes } from './CallsTimes';
import { CallsTimesEvolution } from './CallsTimesEvolution';
import { CallsTimesMonthlyEvolution } from './CallsTimesMonthlyEvolution';

const CallsResults = () => {
    const { isLoading } = useServicesChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <CallsTimes />
            <div className="charts-side-by-side-dashboards">
                <CallsTimesEvolution />
                <CallsTimesMonthlyEvolution />
            </div>
        </>
    );
};

export default CallsResults;
